import React from 'react'

import { TextField ,Grid, Typography} from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setPhproductFilterCriteria } from 'store/slice/PharmaSlice';

export default function PhproductFilterCriteria() {
    const dispatch = useDispatch();
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.phproductDashboard);
        
    const {partyList} = useSelector((state)=>state.pharmaslice);    
    const {phproductstatusList} = useSelector((state)=>state.pharmaslice);    
    const {phproductformList} = useSelector((state)=>state.pharmaslice);    
    const {phpackagingmaterialList} = useSelector((state)=>state.pharmaslice);
    
const updatePartynameCriteria = (partyname) =>{
        dispatch(setPhproductFilterCriteria(
            {
                ...filterCriteria,
                partyname:partyname
        }))
    }
const updateTitleCriteria = (title) =>{
        dispatch(setPhproductFilterCriteria(
            {
                ...filterCriteria,
                title:title
        }))
    }
const updateStatusCriteria = (status) =>{
        dispatch(setPhproductFilterCriteria(
            {
                ...filterCriteria,
                status:status
        }))
    }

    return (

        <Grid container direction="row" lg={12} sx={{justifyContent:'center'}}>
                    <Grid item padding={1}>
                        <FormControl  style={{minWidth: 250}} size="small">
                        <InputLabel id="ratinginput">Party Name</InputLabel>
                        <Select
                            labelId="partynameselect"
                            id="partyname"
                            value={filterCriteria.partyname}
                            name="partyname"
                            label="Party Name"
                            onChange={(e)=>updatePartynameCriteria(e.target.value)}
                            defaultValue={filterCriteria.producttypeid}
                            >
                            <MenuItem value="">None</MenuItem>
                            {
                                partyList && partyList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                            }
                        </Select>
                    </FormControl>
                    </Grid>

                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Title"
                            name="title"
                            value={filterCriteria.title}
                            onChange={(e)=>updateTitleCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    <Grid item padding={1}>
                        <FormControl  style={{minWidth: 250}} size="small">
                        <InputLabel id="ratinginput">Status</InputLabel>
                        <Select
                            labelId="statusselect"
                            id="status"
                            value={filterCriteria.status}
                            name="status"
                            label="Status"
                            onChange={(e)=>updateStatusCriteria(e.target.value)}
                            defaultValue={filterCriteria.producttypeid}
                            >
                            <MenuItem value="">None</MenuItem>
                            {
                                phproductstatusList && phproductstatusList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                            }
                        </Select>
                    </FormControl>
                    </Grid>


        </Grid>
    )

}